define([
	"dojo/_base/declare",
	"Apparel/NewColorway"
], function(declare, NewColorway) {

	return declare(NewColorway, {
		constructor: function() {
			this.m_idAttrParent = "ProductColors";
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default value for color and colorspec
			const themeColor = this.getContext().getColumnNode();
			view.addFixedValue("ColorwayThemeColor", themeColor.$URL);
			view.addFixedValue("ColorSpecification", themeColor.Actual);
			this.inherited(arguments);
		},

		postProcessSuccess: function() {
			// summary: refresh row
			this.widget.redrawNode(this.refNode);
		},

		_canNavigate: function() {
			// summary: disallow Save & Go in this case
			return false;
		},

		_canRepeat: function() {
			// summary: disallow Save & New in this case
			return false;
		}
	});
});